import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { AppName } from "../../../../util/app";
import assessments from "./assessments.json";
import Select from "react-dropdown-select";
import { toast } from "react-toastify";

const NewRiskMatrix = ({ onSubmit, onCancel }) => {
    const [model, setModel] = useState({
        comment: "",
        assessments: [],
    });

    const onChangeTarget = (key, value, historical) => {
        const _model = { ...model };
        let found = false;
        for (let index = 0; index < _model.assessments.length; index++) {
            if (_model.assessments[index].key === key) {
                found = true;
                if (value) _model.assessments[index].value = value;
                if (historical) _model.assessments[index].historical = historical;
            }
        }
        if (!found) {
            let _new = { key, value };
            if (historical) _new.historical = historical;
            _model.assessments.push(_new);
        }
        setModel(_model);
    };
    return (
        <>
            <Helmet>
                <title> New Risk Matrix | {AppName}</title>
            </Helmet>

            <form
                onSubmit={(event) => {
                    event.preventDefault();
                    if (assessments.length === model.assessments.length) {
                        onSubmit(model);
                    } else {
                        toast.warn("You must answer all the questions!");
                    }
                }}
            >
                <div className="row">
                    <div className="col-4 bg-primary pl-2">
                        <h5>Risk Matrix</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: "60%", backgroundColor: "aliceblue" }} className="text-center">
                                    <strong>Risk Area</strong>
                                </td>
                                <td style={{ width: "20%", backgroundColor: "aliceblue" }} className="text-center">
                                    <strong>Current</strong>
                                </td>
                                <td style={{ width: "20%", backgroundColor: "aliceblue" }} className="text-center">
                                    <strong>Historical</strong>
                                </td>
                            </tr>
                            {assessments.map((item, idx) => (
                                <tr key={idx}>
                                    <td style={{ width: "60%", backgroundColor: "aliceblue" }}>
                                        <strong>{item}</strong>
                                    </td>
                                    <td style={{ width: "20%" }}>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input onChange={() => onChangeTarget(item, "Yes", null)} type="radio" className="custom-control-input" name={item} id={idx + "yes"} />
                                            <label className="custom-control-label" htmlFor={idx + "yes"}>
                                                Yes
                                            </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input onChange={() => onChangeTarget(item, "No", null)} type="radio" name={item} className="custom-control-input" id={idx + "no"} />
                                            <label className="custom-control-label" htmlFor={idx + "no"}>
                                                No
                                            </label>
                                        </div>
                                    </td>
                                    <td style={{ width: "20%" }}>
                                        <Select
                                            key={item}
                                            onChange={(items) => {
                                                onChangeTarget(item, null, items[0].value);
                                            }}
                                            options={[
                                                { label: "Yes", value: "Yes" },
                                                { label: "No", value: "No" },
                                            ]}
                                            placeholder="-- Please Select --"
                                            valueField="value"
                                            labelField="label"
                                        />
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <td style={{ width: "60%", backgroundColor: "aliceblue" }}>
                                    <strong>Is there any added comment od additional information?</strong>
                                </td>
                                <td colSpan="2" style={{ width: "20%" }} className="text-center">
                                    <div className="form-group">
                                        <textarea
                                            onChange={({ currentTarget }) => setModel({ ...model, comment: currentTarget.value })}
                                            name="comment-id"
                                            id="comment-id"
                                            className="form-control form-control-textarea"
                                            required
                                            rows="6"
                                            placeholder="enter comment here.."
                                        ></textarea>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="text-center mt-5 mb-5">
                    <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default">
                        <i className="material-icons text-danger">cancel</i> Cancel
                    </button>

                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-success">
                        Save Risk Matrix <i className="material-icons">arrow_right_alt</i>
                    </button>
                </div>
            </form>
        </>
    );
};

export default NewRiskMatrix;
